import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import router from './router'
import VueSession from 'vue-session'
import 'bootstrap/dist/js/bootstrap.min'
import i18n from './i18n'
import PortalVue from 'portal-vue'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import HighchartsMore from 'highcharts/highcharts-more'
import SolidGauge from 'highcharts/modules/solid-gauge'
import VariablePie from 'highcharts/modules/variable-pie'
import { msalInstance } from './auth/MsalConfig'
import Api from '@/utils/Api'

Vue.config.productionTip = false

Vue.prototype.$msal = msalInstance

Vue.use(Vuelidate)
Vue.use(VueSession)
Vue.use(PortalVue)
Vue.use(HighchartsVue)
HighchartsMore(Highcharts)
SolidGauge(Highcharts)
VariablePie(Highcharts)
let authReady = false

router.beforeEach((to, from, next) => {
  const lang = to.params.lang || i18n.locale || 'en'
  i18n.locale = lang

  if (!authReady) {
    return next()
  }

  const isLoggedIn = !!localStorage.getItem('token')
  const needsAuth = to.matched.some(r => r.meta.auth)

  if (!isLoggedIn && needsAuth) {
    return next(`/${lang}`)
  }

  next()
})

async function bootstrap () {
  try {
    const response = await msalInstance.handleRedirectPromise()

    if (response?.accessToken && response.account) {
      msalInstance.setActiveAccount(response.account)

      const { data } = await Api.postLoginAzure({
        accessToken: response.accessToken,
        language: i18n.locale.toUpperCase()
      })

      if (!data?.data?.token) {
        throw new Error('Azure login failed')
      }

      localStorage.token = data.data.token
      localStorage.refreshToken = data.data.refreshToken
      localStorage.login = true

      const { data: profile } = await Api.users.me()
      localStorage.profile = JSON.stringify(profile)

      const routing = [...profile.role.permissions]
        .sort((a, b) => a.level - b.level)

      localStorage.setItem('defaultRoute', JSON.stringify(routing[0]))
    }
  } catch (error) {
    console.error('Auth bootstrap error:', error)
    localStorage.clear()
  } finally {
    authReady = true

    new Vue({
      router,
      i18n,
      render: h => h(App)
    }).$mount('#app')

    redirectAfterAuth()
  }
}

function redirectAfterAuth () {
  const token = localStorage.getItem('token')
  if (!token) return

  const profile = JSON.parse(localStorage.getItem('profile'))
  if (!profile) return

  const defaultRouting = JSON.parse(localStorage.getItem('defaultRoute'))
  if (!defaultRouting) return

  const lang = i18n.locale || 'en'

  if (
    (defaultRouting.category === 'my_dhm' ||
      defaultRouting.category === 'all_dhm') &&
    defaultRouting.permissions.includes('add')
  ) {
    router.replace({
      name: 'success-login',
      params: { lang }
    })
  } else {
    router.replace({
      name: defaultRouting.category,
      params: { lang }
    })
  }
}

bootstrap()
